import React from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileWorkExperienceEditor.scss'
import { Form, FormCheck, Row, Col } from 'react-bootstrap'
import FieldGroup from '../../../common/forms/FieldGroup'
import EditButton from '../../../common/forms/EditButton'
import YearMonthPicker from '../../../common/forms/YearMonthPicker'

let positionTouched = false

const handlePositionFocus = (event) => {
  positionTouched = true
}

const handlePositionBlur = (event) => {
  let value = event.target.value
  getPositionvalidationstate(positionTouched, value)
}

const getPositionvalidationstate = (touched, value) => {
  if (!touched) {
    return {
      isInvalid: false,
      message: null,
      valid: false
    }
  }

  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter a position',
      valid: false
    }
  }

  if (value.length === 0) {
    return {
      isInvalid: true,
      message: 'Please enter a position',
      valid: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true
  }
}

const handlePositionChange = (handleChange, event, validationstate) => {
  let value = event.target.value
  let validationResult = getPositionvalidationstate(positionTouched, value)
  handleChange({
    position: validationResult,
    company: validationstate.company
  }, value)
}

let companyTouched = false

const handleCompanyFocus = (event) => {
  companyTouched = true
}

const handleCompanyBlur = (event) => {
  let value = event.target.value
  getPositionvalidationstate(companyTouched, value)
}

const getCompanyvalidationstate = (touched, value) => {
  if (!touched) {
    return {
      isInvalid: false,
      message: null,
      valid: false
    }
  }

  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter a company',
      valid: false
    }
  }

  if (value.length === 0) {
    return {
      isInvalid: true,
      message: 'Please enter a company',
      valid: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true
  }
}

const handleCompanyChange = (handleChange, event, validationstate) => {
  let value = event.target.value
  let validationResult = getCompanyvalidationstate(companyTouched, value)
  handleChange({
    company: validationResult,
    position: validationstate.position
  }, value)
}

const validateStartEndYear = (handleStartYear, handleEndYear, startYear, endYear, startYearValidationResult, endYearValidationResult, validateMonths) => {
  const successfullResult = {
    isInvalid: false,
    message: null,
    valid: true
  }

  const startYearResult = {
    isInvalid: true,
    message: 'Start year cannot be greater than end year',
    valid: false
  }

  const endYearResult = {
    isInvalid: true,
    message: 'End year cannot be less than start year',
    valid: false
  }

  const startIndependentlyInvalid = !startYearValidationResult.valid && startYearValidationResult.message !== startYearResult.message
  const endIndependentlyInvalid = !endYearValidationResult.valid && endYearValidationResult.message !== endYearResult.message

  // If either year has its own (non-cross-field) validation error, keep both results and skip
  // the start>end comparison - but still COMMIT both, so the field the user just corrected is
  // not discarded (which previously wedged Save when both years were invalid at once).
  if (startIndependentlyInvalid || endIndependentlyInvalid) {
    handleStartYear(startYearValidationResult, startYear)
    handleEndYear(endYearValidationResult, endYear)
    validateMonths(startYear, endYear)
    return
  }

  if (endYear !== null) {
    if (endYear < startYear) {
      startYearValidationResult = startYearResult
      endYearValidationResult = endYearResult
    } else {
      startYearValidationResult = successfullResult
      endYearValidationResult = successfullResult
    }
  }

  handleStartYear(startYearValidationResult, startYear)
  handleEndYear(endYearValidationResult, endYear)
  validateMonths(startYear, endYear)
}

const validateStartEndMonth = (handleStartMonth, handleEndMonth, startMonth, endMonth, startYear, endYear, startMonthValidationResult, endMonthValidtionResult) => {
  const successfullResult = {
    isInvalid: false,
    message: null,
    valid: true
  }

  const startMonthResult = {
    isInvalid: true,
    message: 'Start month cannot be greater than end month',
    valid: false
  }

  const endMonthResult = {
    isInvalid: true,
    message: 'End month cannot be less than start month',
    valid: false
  }

  if (endYear !== null) {
    if (endYear === startYear) {
      if (endMonth < startMonth) {
        startMonthValidationResult = startMonthResult
        endMonthValidtionResult = endMonthResult
      } else {
        startMonthValidationResult = successfullResult
        endMonthValidtionResult = successfullResult
      }
    } else {
      startMonthValidationResult = successfullResult
      endMonthValidtionResult = successfullResult
    }
  }

  handleStartMonth(startMonthValidationResult, startMonth)
  handleEndMonth(endMonthValidtionResult, endMonth)
}

const AdviserWorkExperienceEditor = ({
    formIsValid,
    experience,
    editingWorkExperience,
    dateHandleChange,
    positionStartMonth,
    positionStartYear,
    positionEndMonth,
    positionEndYear,
    validationstate,
    stopEditingWorkExperience,
    cancelEditingWorkExperience,
    positionHandleChange,
    companyHandleChange,
    handlePositionStartMonth,
    handlePositionStartYear,
    handlePositionEndMonth,
    handlePositionEndYear,
    handleCurrentEndYear
  }) => (
    <div className={styles['form-bottom-margin']}>
      <Form.Group>
        <FieldGroup
          required
          value={experience.position !== null ? experience.position : ''}
          onChange={(event) => {
            handlePositionChange(positionHandleChange, event, validationstate)
          }}
          placeholder='Position'
          label='Position'
          isInvalid={validationstate.position.isInvalid}
          message={validationstate.position.message}
          onBlur={handlePositionBlur}
          onFocus={handlePositionFocus}
        />
        <FieldGroup
          required
          value={experience.company !== null ? experience.company : ''}
          onChange={(event) => {
            handleCompanyChange(companyHandleChange, event, validationstate)
          }}
          placeholder='Company'
          label='Company'
          message={validationstate.company.message}
          isInvalid={validationstate.company.isInvalid}
          onBlur={handleCompanyBlur}
          onFocus={handleCompanyFocus}
        />
        <Form.Group>
          <Row>
            <Col className="d-none d-sm-block" sm={6} md={6} lg={6}>
              <YearMonthPicker
                label={'Start'}
                month={positionStartMonth !== null ? positionStartMonth : 0}
                year={parseInt(positionStartYear)}
                handleMonth={(value) => {
                  validateStartEndMonth(handlePositionStartMonth, handlePositionEndMonth, value, positionEndMonth, positionStartYear, positionEndYear, validationstate.startMonth, validationstate.endMonth)
                }}
                handleYear={(validationResult, value) => {
                  value = parseInt(value)
                  validateStartEndYear(handlePositionStartYear, handlePositionEndYear, value, positionEndYear, validationResult, validationstate.endYear, (startYear, endYear) => {
                    validateStartEndMonth(handlePositionStartMonth, handlePositionEndMonth, positionStartMonth, positionEndMonth, startYear, endYear, validationstate.startMonth, validationstate.endMonth)
                  })
                }}
                handleChange={dateHandleChange}
                yearisInvalid={validationstate.startYear}
                monthisInvalid={validationstate.startMonth}
              />
            </Col>
            <Col className="d-none d-sm-block" sm={6} md={6} lg={6}>
              {!experience.isCurrentJob ? <YearMonthPicker
                label={'End'}
                disabled={experience.isCurrentJob}
                month={positionEndMonth !== null ? positionEndMonth : 11}
                year={positionEndYear !== null ? parseInt(positionEndYear) : 0}
                handleMonth={(value) => {
                  validateStartEndMonth(handlePositionStartMonth, handlePositionEndMonth, positionStartMonth, value, positionStartYear, positionEndYear, validationstate.startMonth, validationstate.endMonth)
                }}
                handleYear={(validationResult, value) => {
                  value = parseInt(value)
                  validateStartEndYear(handlePositionStartYear, handlePositionEndYear, positionStartYear, value, validationstate.startYear, validationResult, (startYear, endYear) => {
                    validateStartEndMonth(handlePositionStartMonth, handlePositionEndMonth, positionStartMonth, positionEndMonth, startYear, endYear, validationstate.startMonth, validationstate.endMonth)
                  })
                }}
                handleChange={dateHandleChange}
                yearisInvalid={validationstate.endYear}
                monthisInvalid={validationstate.endMonth}
              /> : ''}
            </Col>
        </Row>
        <FormCheck
          type="checkbox"
          checked={experience.isCurrentJob}
          value={experience.isCurrentJob ? '' : positionEndYear}
          onChange={() => {
            handleCurrentEndYear()
          }}
          label="Current Job"
        />

      </Form.Group>
        <EditButton
          formIsValid={formIsValid}
          editing={editingWorkExperience}
          cancelEditing={() => {
            cancelEditingWorkExperience()
          }}
          stopEditing={() => {
            stopEditingWorkExperience()
          }}
        />
      </Form.Group>
    </div>
  )

AdviserWorkExperienceEditor.propTypes = {
  formIsValid: PropTypes.bool.isRequired,
  experience: PropTypes.object.isRequired,
  editingWorkExperience: PropTypes.bool.isRequired,
  positionStartMonth: PropTypes.number,
  positionStartYear: PropTypes.number,
  positionEndMonth: PropTypes.number,
  positionEndYear: PropTypes.number,
  validationstate: PropTypes.object.isRequired,
  stopEditingWorkExperience: PropTypes.func.isRequired,
  cancelEditingWorkExperience: PropTypes.func.isRequired,
  positionHandleChange: PropTypes.func.isRequired,
  companyHandleChange: PropTypes.func.isRequired,
  dateHandleChange: PropTypes.func.isRequired,
  handlePositionStartMonth: PropTypes.func.isRequired,
  handlePositionStartYear: PropTypes.func.isRequired,
  handlePositionEndMonth: PropTypes.func.isRequired,
  handlePositionEndYear: PropTypes.func.isRequired,
  handleCurrentEndYear: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node, 
    PropTypes.arrayOf(PropTypes.node)
  ])
}

export default ( (AdviserWorkExperienceEditor))
